import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledCollectionFieldProfileCardContent = styled(Box)`
  &.CollectionFieldProfileCardContent {
    display: flex;
    gap: ${props => props.theme.layout('1sp')};
    width: 100%;
    
    .CollectionFieldProfileCardContent {
      &-content {
        display: flex;
        flex-direction: row;
        column-gap: ${props => props.theme.layout('1sp')};
        width: 100%;

        .FieldCard {
          flex-grow: 1;
          width: 1px;
          
          &-suggested {
            width: unset;
          }
        }
        
        .CollectionFieldsSectionPanel {
          width: 100%;
          max-height: 60vh;
        }

        .FormControl {
          &.FormField-name-autoLookup {
            .ListField-container {
              flex-grow: unset;
            }
          }
        }
      }
    }
  }

  &:not(.CollectionFieldProfileCardContent-isEditing) {
    &.CollectionFieldProfileCardContent-isAddNew {
      width: 100%;
      height: 100%;
      padding: 0;
      min-height: ${props => props.theme.layout(230)};
      max-height: ${props => props.theme.layout(230)};
      background-color: ${props => props.theme.property(`palette.primary.states.focus`)};

      .CollectionFieldProfileCardContent-content {
        width: 100%;
        height: 100%;

        .Card {
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: transparent;
        }
      }
    }
  }

  ${ComponentStyles}
`;

StyledCollectionFieldProfileCardContent.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionFieldProfileCardContent;
